import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaExternalLinkAlt } from 'react-icons/fa';
import './FeaturedProjects.css';

const FeaturedProjects = () => {
  const projects = [
    {
      id: 1,
      title: 'Ramkus Dairy Website',
      category: 'web',
      image: '/images/ram.png',
      description: 'A modern dairy business website with product showcase, online ordering, and delivery information for local customers.',
      technologies: ['React', 'Tailwind CSS', 'Node.js'],
      live: 'https://ramkusdairy.shop/'
    },
    {
      id: 2,
      title: 'Company Portfolio & Internship System',
      category: 'web',
      image: '/images/shi.png',
      description: 'Corporate website with internship application system, service showcase, and lead generation features.',
      technologies: ['React', 'Bootstrap', 'Node.js', 'MongoDB'],
      live: 'https://www.shiwansh.com/'
    },
   {
  id: 3,
  title: 'NSGO India - National Scouts & Guides Organization',
  category: 'web',
  image: '/images/ngo1.png',
  description: 'Official website of NSGO India, a national and international organization focused on youth empowerment, leadership development, community service, disaster relief, environmental initiatives, and volunteer development.',
  technologies: ['Next.js', 'Node.js', 'MongoDB'],
  live: 'https://nsgoindiaintl.org/'
}
  ];

  return (
    <section className="featured-projects" id="projects">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="section-header"
        >
          <span className="section-subtitle">Our Work</span>
          <h2 className="section-title">
            Featured <span className="gradient-text">Projects</span>
          </h2>
          <p className="section-description">
            Explore some of our latest and most innovative projects that have helped businesses achieve their goals.
          </p>
        </motion.div>

        <div className="projects-grid">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="project-card"
            >
              <div className="project-image">
                <img src={project.image} alt={project.title} />
                <div className="project-overlay">
                  <div className="project-links">
                    <a href={project.live} target="_blank" rel="noopener noreferrer" className="project-link">
                      <FaExternalLinkAlt />
                    </a>
                  </div>
                </div>
                <span className="project-category">{project.category}</span>
              </div>
              
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-technologies">
                  {project.technologies.map((tech, i) => (
                    <span key={i} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="projects-cta"
        >
          <Link to="/projects" className="btn btn-outline">
            View All Projects <FaArrowRight />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedProjects;